import React from 'react';
import Edit from '../../../containers/rest/Edit';
import Form from '../components/Form';

const ProductCatalogsEdit = props => (
  <Edit {...props} resource="productTypes">
    <Form />
  </Edit>
);

ProductCatalogsEdit.propTypes = {};

export default ProductCatalogsEdit;
